module.exports = __webpack_public_path__ + "static/media/gov_canada2.a8d055db.svg";